export default __webpack_public_path__ + "static/media/Safari.5d35b053.svg";